import { IconButton, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import Image from 'next/image';

import copyIco from '@/public/images/ico-copy.svg';
import facebookIco from '@/public/images/ico-facebook-share.svg';
import whatsAppIco from '@/public/images/ico-whatsapp.svg';
import SimpleModal from './simple-modal';

interface Props {
  open: boolean;
  handleClose: () => void;
  link: string;
  utmContent: string;
}

export default function ShareJobOpportunityModal({ open, handleClose, link, utmContent }: Props) {
  return (
    <SimpleModal open={open} onClose={handleClose} aria-describedby="modal-success">
      <Box>
        <Typography variant="subtitle1">Compartilhar com:</Typography>
        <div className="d-flex align-items-center">
          <IconButton>
            <a
              href={`https://www.facebook.com/sharer/sharer.php?u=${link}?utm_source=facebook&utm_medium=social&utm_campaign=job_public_share&utm_content=${utmContent}`}
              target="_blank"
              rel="noreferrer"
            >
              <Image width={32} src={facebookIco} alt="Compartilhar com Facebook" />
            </a>
          </IconButton>
          <IconButton>
            <a
              href={`https://api.whatsapp.com/send?text=${link}?utm_source=whatsapp&utm_medium=social&utm_campaign=job_public_share&utm_content=${utmContent}`}
              target="_blank"
              rel="noreferrer"
            >
              <Image width={32} src={whatsAppIco} alt="Compartilhar com WhatsApp" />
            </a>
          </IconButton>
          <button
            className="btn btn-full"
            onClick={() =>
              navigator.clipboard.writeText(
                `${link}?utm_source=direct&utm_medium=copy_link&utm_campaign=job_public_share&utm_content=${utmContent}`,
              )
            }
          >
            <Image width={32} src={copyIco} alt="Copiar link de compartilhamento" />
            Copiar link
          </button>
        </div>
      </Box>
    </SimpleModal>
  );
}
